// A temporary fix for https://github.com/bengourley/currency-symbol-map/issues/41
import currencySymbolMap from 'currency-symbol-map';
export const getSymbolFromCurrency = (currency) => {
    return currency.toUpperCase() === 'PEN'
        ? 'S/'
        : currencySymbolMap(currency) ?? '';
};
//# sourceMappingURL=currencySymbolMap.js.map